import { render, staticRenderFns } from "./SellSkins.vue?vue&type=template&id=265c7228&scoped=true"
import script from "./SellSkins.vue?vue&type=script&lang=js"
export * from "./SellSkins.vue?vue&type=script&lang=js"
import style0 from "./SellSkins.vue?vue&type=style&index=0&id=265c7228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c7228",
  null
  
)

export default component.exports